import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img/exam-bg.jpg'
import _imports_1 from '../assets/img/exam-title.png'
import _imports_2 from '../assets/img/result-icon.png'
import _imports_3 from '../assets/img/code.png'


const _hoisted_1 = {
  class: "bg share-page",
  id: "capture"
}
const _hoisted_2 = { class: "share-page-wrapper" }
const _hoisted_3 = { class: "result-content" }
const _hoisted_4 = { class: "result-content-desc" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, "作答的成绩：", -1)
const _hoisted_6 = { style: {"font-size":"8vw"} }
const _hoisted_7 = { class: "code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("img", {
      src: _imports_0,
      class: "bg-c",
      onLoad: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imgLoad('bg')))
    }, null, 32),
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        class: "title",
        alt: "title",
        src: _imports_1,
        onLoad: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imgLoad('title')))
      }, null, 32),
      _createVNode("div", _hoisted_3, [
        _createVNode("img", {
          class: "icon",
          alt: "icon",
          src: _imports_2,
          onLoad: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imgLoad('icon')))
        }, null, 32),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", null, _toDisplayString(_ctx.userInfo.nickname) + "，感谢您的作答！", 1),
          _createVNode("div", null, "您共用：" + _toDisplayString(_ctx.myResult.timesStr), 1),
          _hoisted_5,
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.myResult.score) + "分", 1)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("img", {
          src: _imports_3,
          onLoad: _cache[4] || (_cache[4] = ($event: any) => (_ctx.imgLoad('code')))
        }, null, 32)
      ])
    ])
  ]))
}